import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../core/Error.js";
import e from "../../core/Logger.js";
import { isNone as n, isSome as o } from "../../core/maybe.js";
import { isPoint as r, isPolygon as s, isPolyline as c, isMultipoint as l } from "../../geometry/support/jsonUtils.js";
import u from "./OptimizedFeature.js";
import i from "./OptimizedFeatureSet.js";
import f from "./OptimizedGeometry.js";

function h(t, e) {
  return t ? e ? 4 : 3 : e ? 3 : 2;
}

var a = e.getLogger("esri.tasks.support.optimizedFeatureSet"),
    g = {
  esriGeometryPoint: 0,
  esriGeometryPolyline: 2,
  esriGeometryPolygon: 3,
  esriGeometryMultipoint: 0
},
    d = function d(t, e, n, o, r, s) {
  t[n] = r, t[n + 1] = s;
},
    m = function m(t, e, n, o, r, s) {
  t[n] = r, t[n + 1] = s, t[n + 2] = e[o + 2];
},
    y = function y(t, e, n, o, r, s) {
  t[n] = r, t[n + 1] = s, t[n + 2] = e[o + 3];
},
    p = function p(t, e, n, o, r, s) {
  t[n] = r, t[n + 1] = s, t[n + 2] = e[o + 2], t[n + 3] = e[o + 3];
};

function I(t, e, n, o) {
  if (t) {
    if (n) return e && o ? p : m;
    if (e && o) return y;
  } else if (e && o) return m;

  return d;
}

function b(_ref, n) {
  var t = _ref.scale,
      e = _ref.translate;
  return Math.round((n - e[0]) / t[0]);
}

function M(_ref2, n) {
  var t = _ref2.scale,
      e = _ref2.translate;
  return Math.round((e[1] - n) / t[1]);
}

function w(_ref3, n) {
  var t = _ref3.scale,
      e = _ref3.translate;
  return n * t[0] + e[0];
}

function N(_ref4, n) {
  var t = _ref4.scale,
      e = _ref4.translate;
  return e[1] - n * t[1];
}

function G(t, e, n) {
  return t ? e ? n ? k(t) : P(t) : n ? Z(t) : T(t) : null;
}

function T(t) {
  var e = t.coords;
  return {
    x: e[0],
    y: e[1]
  };
}

function F(t, e) {
  return t.coords[0] = e.x, t.coords[1] = e.y, t;
}

function P(t) {
  var e = t.coords;
  return {
    x: e[0],
    y: e[1],
    z: e[2]
  };
}

function x(t, e) {
  return t.coords[0] = e.x, t.coords[1] = e.y, t.coords[2] = e.z, t;
}

function Z(t) {
  var e = t.coords;
  return {
    x: e[0],
    y: e[1],
    m: e[2]
  };
}

function j(t, e) {
  return t.coords[0] = e.x, t.coords[1] = e.y, t.coords[2] = e.m, t;
}

function k(t) {
  var e = t.coords;
  return {
    x: e[0],
    y: e[1],
    z: e[2],
    m: e[3]
  };
}

function E(t, e) {
  return t.coords[0] = e.x, t.coords[1] = e.y, t.coords[2] = e.z, t.coords[3] = e.m, t;
}

function z(t, e, n, r) {
  var s = T;
  n && r ? s = k : n ? s = P : r && (s = Z);

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _c = _step.value;

      var _e = _c.geometry,
          _n = _c.attributes,
          _r = o(_e) ? s(_e) : null;

      t.push({
        attributes: _n,
        geometry: _r
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t;
}

function S(t, e) {
  return t && e ? E : t ? x : e ? j : F;
}

function v(t, e, n, o, r) {
  var s = S(n, o);

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _c2 = _step2.value;
      var _e2 = _c2.geometry,
          _n2 = _c2.attributes;

      var _o = void 0;

      _e2 && (_o = s(new f(), _e2)), t.push(new u(_o, _n2, null, _n2[r]));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return t;
}

function V(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : S(null != e.z, null != e.m);
  return n(t, e);
}

function Y(t, e, n, o) {
  var _iterator3 = _createForOfIteratorHelper(e),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _r2 = _step3.value;
      var _e3 = _r2.geometry,
          _s = _r2.attributes;

      var _c3 = void 0;

      _e3 && (_c3 = _(_e3, n, o)), t.push({
        attributes: _s,
        geometry: _c3
      });
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return t;
}

function _(t, e, o) {
  if (n(t)) return null;
  var r = h(e, o),
      s = [];

  for (var _n3 = 0; _n3 < t.coords.length; _n3 += r) {
    var _e4 = [];

    for (var _o2 = 0; _o2 < r; _o2++) {
      _e4.push(t.coords[_n3 + _o2]);
    }

    s.push(_e4);
  }

  return e ? o ? {
    points: s,
    hasZ: e,
    hasM: o
  } : {
    points: s,
    hasZ: e
  } : o ? {
    points: s,
    hasM: o
  } : {
    points: s
  };
}

function O(t, e, n, o, r) {
  var s = h(n, o);

  var _iterator4 = _createForOfIteratorHelper(e),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _c4 = _step4.value;
      var _e5 = _c4.geometry,
          _n4 = _c4.attributes;

      var _o3 = void 0;

      _e5 && (_o3 = A(new f(), _e5, s)), t.push(new u(_o3, _n4, null, _n4[r]));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return t;
}

function A(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : h(e.hasZ, e.hasM);
  t.lengths[0] = e.points.length;
  var o = t.coords;
  var r = 0;

  var _iterator5 = _createForOfIteratorHelper(e.points),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _s2 = _step5.value;

      for (var _t = 0; _t < n; _t++) {
        o[r++] = _s2[_t];
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return t;
}

function L(t, e, n, r) {
  var _iterator6 = _createForOfIteratorHelper(e),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _s3 = _step6.value;
      var _e6 = _s3.geometry,
          _c5 = _s3.attributes;

      var _l = void 0;

      o(_e6) && (_l = U(_e6, n, r)), t.push({
        attributes: _c5,
        geometry: _l
      });
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return t;
}

function U(t, e, n) {
  if (!t) return null;
  var o = h(e, n),
      r = t.coords,
      s = t.lengths,
      c = [];
  var l = 0;

  var _iterator7 = _createForOfIteratorHelper(s),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _u = _step7.value;
      var _t2 = [];

      for (var _e7 = 0; _e7 < _u; _e7++) {
        var _e8 = [];

        for (var _t3 = 0; _t3 < o; _t3++) {
          _e8.push(r[l++]);
        }

        _t2.push(_e8);
      }

      c.push(_t2);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return e ? n ? {
    paths: c,
    hasZ: e,
    hasM: n
  } : {
    paths: c,
    hasZ: e
  } : n ? {
    paths: c,
    hasM: n
  } : {
    paths: c
  };
}

function q(t, e, n, o, r) {
  var s = h(n, o);

  var _iterator8 = _createForOfIteratorHelper(e),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _c6 = _step8.value;
      var _e9 = _c6.geometry,
          _n5 = _c6.attributes;

      var _o4 = void 0;

      _e9 && (_o4 = $(new f(), _e9, s)), t.push(new u(_o4, _n5, null, _n5[r]));
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return t;
}

function $(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : h(e.hasZ, e.hasM);
  var o = t.lengths,
      r = t.coords;
  var s = 0;

  var _iterator9 = _createForOfIteratorHelper(e.paths),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _c7 = _step9.value;

      var _iterator10 = _createForOfIteratorHelper(_c7),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _t4 = _step10.value;

          for (var _e10 = 0; _e10 < n; _e10++) {
            r[s++] = _t4[_e10];
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      o.push(_c7.length);
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return t;
}

function R(t, e, n, r) {
  var _iterator11 = _createForOfIteratorHelper(e),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var _s4 = _step11.value;
      var _e11 = _s4.geometry,
          _c8 = _s4.attributes,
          _l2 = _s4.centroid;

      var _u2 = void 0;

      if (o(_e11) && (_u2 = C(_e11, n, r)), _l2) {
        var _e12 = T(_l2);

        t.push({
          attributes: _c8,
          centroid: _e12,
          geometry: _u2
        });
      } else t.push({
        attributes: _c8,
        geometry: _u2
      });
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return t;
}

function C(t, e, n) {
  if (!t) return null;
  var o = h(e, n),
      r = t.coords,
      s = t.lengths,
      c = [];
  var l = 0;

  var _iterator12 = _createForOfIteratorHelper(s),
      _step12;

  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _u3 = _step12.value;
      var _t5 = [];

      for (var _e13 = 0; _e13 < _u3; _e13++) {
        var _e14 = [];

        for (var _t6 = 0; _t6 < o; _t6++) {
          _e14.push(r[l++]);
        }

        _t5.push(_e14);
      }

      c.push(_t5);
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }

  return e ? n ? {
    rings: c,
    hasZ: e,
    hasM: n
  } : {
    rings: c,
    hasZ: e
  } : n ? {
    rings: c,
    hasM: n
  } : {
    rings: c
  };
}

function B(t, e, n, r, s) {
  var _iterator13 = _createForOfIteratorHelper(e),
      _step13;

  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var _c9 = _step13.value;
      var _e15 = _c9.geometry,
          _l3 = _c9.centroid,
          _i = _c9.attributes;

      var _h = void 0;

      _e15 && (_h = D(new f(), _e15, n, r)), o(_l3) ? t.push(new u(_h, _i, F(new f(), _l3), _i[s])) : t.push(new u(_h, _i, null, _i[s]));
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }

  return t;
}

function D(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.hasZ;
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.hasM;
  return H(t, e.rings, n, o), t;
}

function H(t, e, n, o) {
  var r = h(n, o),
      s = t.lengths,
      c = t.coords;
  var l = 0;
  s.length = c.length = 0;

  var _iterator14 = _createForOfIteratorHelper(e),
      _step14;

  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var _u4 = _step14.value;

      var _iterator15 = _createForOfIteratorHelper(_u4),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _t7 = _step15.value;

          for (var _e16 = 0; _e16 < r; _e16++) {
            c[l++] = _t7[_e16];
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      s.push(_u4.length);
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }

  return t;
}

var J = [],
    K = [];

function Q(t, e, n, o, r) {
  J[0] = t;

  var _W = W(K, J, e, n, o, r),
      _W2 = _slicedToArray(_W, 1),
      s = _W2[0];

  return J.length = K.length = 0, s;
}

function W(e, n, o, r, s, c) {
  if (e.length = 0, !o) {
    var _iterator16 = _createForOfIteratorHelper(n),
        _step16;

    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var _t8 = _step16.value;
        var _n6 = _t8.attributes[c];
        e.push(new u(null, _t8.attributes, null, _n6));
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }

    return e;
  }

  switch (o) {
    case "esriGeometryPoint":
      return v(e, n, r, s, c);

    case "esriGeometryMultipoint":
      return O(e, n, r, s, c);

    case "esriGeometryPolyline":
      return q(e, n, r, s, c);

    case "esriGeometryPolygon":
      return B(e, n, r, s, c);

    default:
      a.error("convertToFeatureSet:unknown-geometry", new t("Unable to parse unknown geometry type '".concat(o, "'"))), e.length = 0;
  }

  return e;
}

function X(e, n, o, r, s, c) {
  var l = e.length;

  switch (o) {
    case "esriGeometryPoint":
      v(e, n, r, s, c);
      break;

    case "esriGeometryMultipoint":
      O(e, n, r, s, c);
      break;

    case "esriGeometryPolyline":
      q(e, n, r, s, c);
      break;

    case "esriGeometryPolygon":
      B(e, n, r, s, c);
      break;

    default:
      a.error("convertToFeatureSet:unknown-geometry", new t("Unable to parse unknown geometry type '".concat(o, "'")));
  }

  for (var _t9 = 0; _t9 < n.length; _t9++) {
    e[_t9 + l].geometryType = o, e[_t9 + l].insertAfter = n[_t9].insertAfter, e[_t9 + l].groupId = n[_t9].groupId;
  }

  return e;
}

function tt(t, e, n, o) {
  K[0] = t, rt(J, K, e, n, o);
  var r = J[0];
  return J.length = K.length = 0, r;
}

function et(e, o, u) {
  if (n(e)) return null;
  var i = new f();

  if ("hasZ" in e && null == o && (o = e.hasZ), "hasM" in e && null == u && (u = e.hasM), r(e)) {
    return S(null != o ? o : null != e.z, null != u ? u : null != e.m)(i, e);
  }

  return s(e) ? D(i, e, o, u) : c(e) ? $(i, e, h(o, u)) : l(e) ? A(i, e, h(o, u)) : void a.error("convertFromGeometry:unknown-geometry", new t("Unable to parse unknown geometry type '".concat(e, "'")));
}

function nt(e, o, r, s) {
  var c = e && ("coords" in e ? e : e.geometry);
  if (n(c)) return null;

  switch (o) {
    case "esriGeometryPoint":
      {
        var _t10 = T;
        return r && s ? _t10 = k : r ? _t10 = P : s && (_t10 = Z), _t10(c);
      }

    case "esriGeometryMultipoint":
      return _(c, r, s);

    case "esriGeometryPolyline":
      return U(c, r, s);

    case "esriGeometryPolygon":
      return C(c, r, s);

    default:
      return void a.error("convertToGeometry:unknown-geometry", new t("Unable to parse unknown geometry type '".concat(o, "'")));
  }
}

function ot(t, e) {
  var _iterator17 = _createForOfIteratorHelper(e),
      _step17;

  try {
    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
      var _n7 = _step17.value;
      t.push({
        attributes: _n7.attributes
      });
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }

  return t;
}

function rt(e, o, r, s, c) {
  if (e.length = 0, n(r)) return ot(e, o);

  switch (r) {
    case "esriGeometryPoint":
      return z(e, o, s, c);

    case "esriGeometryMultipoint":
      return Y(e, o, s, c);

    case "esriGeometryPolyline":
      return L(e, o, s, c);

    case "esriGeometryPolygon":
      return R(e, o, s, c);

    default:
      a.error("convertToFeatureSet:unknown-geometry", new t("Unable to parse unknown geometry type '".concat(r, "'")));
  }

  return e;
}

function st(t) {
  var e = t.objectIdFieldName,
      n = t.spatialReference,
      o = t.transform,
      r = t.fields,
      s = t.hasM,
      c = t.hasZ,
      l = t.features,
      u = t.geometryType,
      i = t.exceededTransferLimit,
      f = t.uniqueIdField,
      h = t.queryGeometry,
      a = t.queryGeometryType,
      g = {
    features: rt([], l, u, c, s),
    fields: r,
    geometryType: u,
    objectIdFieldName: e,
    spatialReference: n,
    uniqueIdField: f,
    queryGeometry: nt(h, a, !1, !1)
  };
  return o && (g.transform = o), i && (g.exceededTransferLimit = i), s && (g.hasM = s), c && (g.hasZ = c), g;
}

function ct(e, n) {
  var o = new i(),
      r = e.hasM,
      s = e.hasZ,
      c = e.features,
      l = e.objectIdFieldName,
      u = e.spatialReference,
      f = e.geometryType,
      h = e.exceededTransferLimit,
      g = e.transform,
      d = e.fields;
  return d && (o.fields = d), o.geometryType = f, o.objectIdFieldName = l || n, o.spatialReference = u, o.objectIdFieldName ? (c && W(o.features, c, f, s, r, o.objectIdFieldName), h && (o.exceededTransferLimit = h), r && (o.hasM = r), s && (o.hasZ = s), g && (o.transform = g), o) : (a.error(new t("optimized-features:invalid-objectIdFieldName", "objectIdFieldName is missing")), o);
}

function lt(t) {
  var e = t.transform,
      n = t.features,
      r = t.hasM,
      s = t.hasZ;
  if (!e) return t;

  var _iterator18 = _createForOfIteratorHelper(n),
      _step18;

  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var _c10 = _step18.value;
      o(_c10.geometry) && mt(_c10.geometry, _c10.geometry, r, s, e), _c10.centroid && mt(_c10.centroid, _c10.centroid, r, s, e);
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }

  return t.transform = null, t;
}

function ut(t, e) {
  var n = e.geometryType,
      o = e.features,
      r = e.hasM,
      s = e.hasZ;
  if (!t) return e;

  for (var _c11 = 0; _c11 < o.length; _c11++) {
    var _e17 = o[_c11],
        _l4 = _e17.weakClone();

    _l4.geometry = new f(), it(_l4.geometry, _e17.geometry, r, s, n, t), _e17.centroid && (_l4.centroid = new f(), it(_l4.centroid, _e17.centroid, r, s, "esriGeometryPoint", t)), o[_c11] = _l4;
  }

  return e.transform = t, e;
}

function it(t, e, o, r, s, c) {
  var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : o;
  var u = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : r;
  if (t.lengths.length && (t.lengths.length = 0), t.coords.length && (t.coords.length = 0), n(e) || !e.coords.length) return null;
  var i = g[s],
      f = e.coords,
      a = e.lengths,
      d = h(o, r),
      m = h(o && l, r && u),
      y = I(o, r, l, u);
  if (!a.length) return y(t.coords, f, 0, 0, b(c, f[0]), M(c, f[1])), t.lengths.length && (t.lengths.length = 0), t.coords.length = d, t;
  var p,
      w,
      N,
      G,
      T = 0,
      F = 0,
      P = F;

  var _iterator19 = _createForOfIteratorHelper(a),
      _step19;

  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var _n8 = _step19.value;
      if (_n8 < i) continue;
      var _e18 = 0;
      F = P, N = p = b(c, f[T]), G = w = M(c, f[T + 1]), y(t.coords, f, F, T, N, G), _e18++, T += d, F += m;

      for (var _o5 = 1; _o5 < _n8; _o5++, T += d) {
        N = b(c, f[T]), G = M(c, f[T + 1]), N === p && G === w || (y(t.coords, f, F, T, N - p, G - w), F += m, _e18++, p = N, w = G);
      }

      _e18 >= i && (t.lengths.push(_e18), P = F);
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }

  return t.coords.length = P, t.coords.length ? t : null;
}

function ft(t, e, n, o, r, s) {
  var c = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : n;
  var l = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : o;
  if (t.lengths.length && (t.lengths.length = 0), t.coords.length && (t.coords.length = 0), !e || !e.coords.length) return null;
  var u = g[r],
      i = e.coords,
      f = e.lengths,
      a = h(n, o),
      d = h(n && c, o && l),
      m = I(n, o, c, l);
  if (!f.length) return m(t.coords, i, 0, 0, i[0], i[1]), t.lengths.length && (t.lengths.length = 0), t.coords.length = a, t;
  var y = 0;
  var p = s * s;

  var _iterator20 = _createForOfIteratorHelper(f),
      _step20;

  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var _h2 = _step20.value;

      if (_h2 < u) {
        y += _h2 * a;
        continue;
      }

      var _e19 = t.coords.length / d,
          _n9 = y,
          _o6 = y + (_h2 - 1) * a;

      m(t.coords, i, t.coords.length, _n9, i[_n9], i[_n9 + 1]), at(t.coords, i, a, p, m, _n9, _o6), m(t.coords, i, t.coords.length, _o6, i[_o6], i[_o6 + 1]);

      var _r3 = t.coords.length / d - _e19;

      _r3 >= u ? t.lengths.push(_r3) : t.coords.length = _e19 * d, y += _h2 * a;
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }

  return t.coords.length ? t : null;
}

function ht(t, e, n, o) {
  var r = t[e],
      s = t[e + 1],
      c = t[n],
      l = t[n + 1],
      u = t[o],
      i = t[o + 1];
  var f = c,
      h = l,
      a = u - f,
      g = i - h;

  if (0 !== a || 0 !== g) {
    var _t11 = ((r - f) * a + (s - h) * g) / (a * a + g * g);

    _t11 > 1 ? (f = u, h = i) : _t11 > 0 && (f += a * _t11, h += g * _t11);
  }

  return a = r - f, g = s - h, a * a + g * g;
}

function at(t, e, n, o, r, s, c) {
  var l,
      u = o,
      i = 0;

  for (var _f = s + n; _f < c; _f += n) {
    l = ht(e, _f, s, c), l > u && (i = _f, u = l);
  }

  u > o && (i - s > n && at(t, e, n, o, r, s, i), r(t, e, t.length, i, e[i], e[i + 1]), c - i > n && at(t, e, n, o, r, i, c));
}

function gt(t, e, o, r) {
  if (n(e) || !e.coords || !e.coords.length) return null;
  var s = h(o, r);
  var c = Number.POSITIVE_INFINITY,
      l = Number.POSITIVE_INFINITY,
      u = Number.NEGATIVE_INFINITY,
      i = Number.NEGATIVE_INFINITY;

  if (e && e.coords) {
    var _t12 = e.coords;

    for (var _e20 = 0; _e20 < _t12.length; _e20 += s) {
      var _n10 = _t12[_e20],
          _o7 = _t12[_e20 + 1];
      c = Math.min(c, _n10), u = Math.max(u, _n10), l = Math.min(l, _o7), i = Math.max(i, _o7);
    }
  }

  return t[0] = c, t[1] = l, t[2] = u, t[3] = i, t;
}

function dt(t, e, n, o) {
  var r = h(n, o),
      s = e.lengths,
      c = e.coords;
  var l = Number.POSITIVE_INFINITY,
      u = Number.POSITIVE_INFINITY,
      i = Number.NEGATIVE_INFINITY,
      f = Number.NEGATIVE_INFINITY,
      a = 0;

  var _iterator21 = _createForOfIteratorHelper(s),
      _step21;

  try {
    for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
      var _h3 = _step21.value;
      var _t13 = c[a],
          _e21 = c[a + 1];
      l = Math.min(_t13, l), u = Math.min(_e21, u), i = Math.max(_t13, i), f = Math.max(_e21, f), a += r;

      for (var _n11 = 1; _n11 < _h3; _n11++, a += r) {
        var _n12 = c[a],
            _o8 = c[a + 1];
        _t13 += _n12, _e21 += _o8, _n12 < 0 && (l = Math.min(l, _t13)), _n12 > 0 && (i = Math.max(i, _t13)), _o8 < 0 ? u = Math.min(u, _e21) : _o8 > 0 && (f = Math.max(f, _e21));
      }
    }
  } catch (err) {
    _iterator21.e(err);
  } finally {
    _iterator21.f();
  }

  return t[0] = l, t[1] = u, t[2] = i, t[3] = f, t;
}

function mt(t, e, n, o, r) {
  var s = e.coords,
      c = e.lengths,
      l = n ? o ? p : m : o ? m : d,
      u = h(n, o);
  if (!s.length) return t !== e && (t.lengths.length = 0, t.coords.length = 0), t;
  if (!c.length) return l(t.coords, s, 0, 0, w(r, s[0]), N(r, s[1])), t !== e && (t.lengths.length = 0, t.coords.length = u), t;

  var _r$scale = _slicedToArray(r.scale, 2),
      i = _r$scale[0],
      f = _r$scale[1];

  var a = 0;

  for (var _h4 = 0; _h4 < c.length; _h4++) {
    var _e22 = c[_h4];
    t.lengths[_h4] = _e22;

    var _n13 = w(r, s[a]),
        _o9 = N(r, s[a + 1]);

    l(t.coords, s, a, a, _n13, _o9), a += u;

    for (var _r4 = 1; _r4 < _e22; _r4++, a += u) {
      _n13 += s[a] * i, _o9 -= s[a + 1] * f, l(t.coords, s, a, a, _n13, _o9);
    }
  }

  return t !== e && (t.lengths.length = c.length, t.coords.length = s.length), t;
}

function yt(t, e, n, o, r, s) {
  var _t$lengths;

  var c = h(n, o),
      l = I(n, o, r, s),
      u = e.coords;
  t.coords.length = 0, t.lengths.length = 0, (_t$lengths = t.lengths).push.apply(_t$lengths, _toConsumableArray(e.lengths));

  for (var _i2 = 0; _i2 < u.length; _i2 += c) {
    l(t.coords, u, t.coords.length, _i2, u[_i2], u[_i2 + 1]);
  }

  return t;
}

function pt(t, e, n, o, r) {
  if (!e || !e.coords || !e.coords.length) return null;
  var s = g[n],
      c = e.coords,
      l = e.lengths,
      u = I(o, r, o, r),
      i = h(o, r);
  var f = 0,
      a = 0,
      d = 0,
      m = 0;

  var _iterator22 = _createForOfIteratorHelper(l),
      _step22;

  try {
    for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
      var _h5 = _step22.value;
      a = m, u(t.coords, c, a, f, c[f], c[f + 1]), f += i;

      var _e23 = c[f],
          _n14 = c[f + 1],
          _o10 = _e23,
          _r5 = _n14,
          _l5 = _n14 / _e23;

      a += i, u(t.coords, c, a, f, _o10, _r5), f += i;

      for (var _s5 = 2; _s5 < _h5; _s5++) {
        _e23 = c[f], _n14 = c[f + 1];

        var _s6 = _n14 / _e23,
            _h6 = _l5 === _s6 || !isFinite(_l5) && !isFinite(_s6),
            _g2 = _h6 && isFinite(_s6) ? _l5 >= 0 && _s6 >= 0 || _l5 <= 0 && _s6 <= 0 : _r5 >= 0 && _n14 >= 0 || _r5 <= 0 && _n14 <= 0;

        _h6 && _g2 ? (_o10 += _e23, _r5 += _n14) : (_o10 = _e23, _r5 = _n14, a += i), u(t.coords, c, a, f, _o10, _r5), f += i, _l5 = _s6;
      }

      a += i;

      var _g = (a - m) / i;

      _g >= s && (t.lengths[d] = _g, m = a, d++);
    }
  } catch (err) {
    _iterator22.e(err);
  } finally {
    _iterator22.f();
  }

  return t.coords.length > m && (t.coords.length = m), t.lengths.length > d && (t.lengths.length = d), t.coords.length && t.lengths.length ? t : null;
}

function It(t, e, n, o) {
  var r = 0,
      s = t[o * e],
      c = t[o * (e + 1)];

  for (var _l6 = 1; _l6 < n; _l6++) {
    var _n15 = s + t[o * (e + _l6)],
        _u5 = c + t[o * (e + _l6) + 1],
        _i3 = (_n15 - s) * (_u5 + c);

    s = _n15, c = _u5, r += _i3;
  }

  return .5 * r;
}

function bt(t, e) {
  var n = t.coords,
      o = t.lengths;
  var r = 0,
      s = 0;

  for (var _c12 = 0; _c12 < o.length; _c12++) {
    s += It(n, r, o[_c12], e), r += _c12;
  }

  return Math.abs(s);
}

function Mt(t, e) {
  var n = t.clone(),
      o = t.coords,
      r = t.lengths;
  var s = 0;

  for (var _c13 = 0; _c13 < r.length; _c13++) {
    var _t14 = r[_c13];
    var _l7 = o[e * s],
        _u6 = o[e * s + 1];

    for (var _r6 = 1; _r6 < _t14; _r6++) {
      var _t15 = o[e * (s + _r6)],
          _c14 = o[e * (s + _r6) + 1],
          _i4 = _t15 - _l7,
          _f2 = _c14 - _u6;

      n.coords[e * (s + _r6)] = _i4, n.coords[e * (s + _r6) + 1] = _f2, _l7 = _t15, _u6 = _c14;
    }

    s += _t14;
  }

  return n;
}

function wt(t, e) {
  if (n(t)) return null;
  var o = t.clone(),
      r = t.coords,
      s = t.lengths;
  var c = 0;

  for (var _n16 = 0; _n16 < s.length; _n16++) {
    var _t16 = s[_n16];
    var _l8 = r[e * c],
        _u7 = r[e * c + 1];

    for (var _n17 = 1; _n17 < _t16; _n17++) {
      var _t17 = _l8 + r[e * (c + _n17)],
          _s7 = _u7 + r[e * (c + _n17) + 1];

      o.coords[e * (c + _n17)] = _t17, o.coords[e * (c + _n17) + 1] = _s7, _l8 = _t17, _u7 = _s7;
    }

    c += _t16;
  }

  return o;
}

export { Q as convertFromFeature, ct as convertFromFeatureSet, W as convertFromFeatures, et as convertFromGeometry, X as convertFromGraphics, A as convertFromMultipoint, O as convertFromMultipointFeatures, H as convertFromNestedArray, V as convertFromPoint, v as convertFromPointFeatures, D as convertFromPolygon, $ as convertFromPolyline, q as convertFromPolylineFeatures, tt as convertToFeature, st as convertToFeatureSet, rt as convertToFeatures, nt as convertToGeometry, _ as convertToMultipoint, Y as convertToMultipointFeatures, G as convertToPoint, C as convertToPolygon, U as convertToPolyline, wt as deltaDecodeGeometry, Mt as deltaEncodeGeometry, ft as generalizeOptimizedGeometry, gt as getBoundsOptimizedGeometry, bt as getQuantizedArea, dt as getQuantizedBoundsOptimizedGeometry, It as getSignedQuantizedRingArea, ut as quantizeOptimizedFeatureSet, it as quantizeOptimizedGeometry, b as quantizeX, M as quantizeY, pt as removeCollinearVectices, yt as removeZMValues, lt as unquantizeOptimizedFeatureSet, mt as unquantizeOptimizedGeometry, w as unquantizeX, N as unquantizeY };